/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ContactType {
    INQUIRY = 'Inquiry',
    NOTIFICATION = 'Notification',
}
